var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-loading-spinner", {
        staticClass: "over-page-loading-spinner",
        attrs: { "is-refresh-loading": _vm.isRefreshLoading },
      }),
      _vm._v(" "),
      _vm.mobileOffersDto.banner
        ? _c("banner", {
            attrs: {
              title: _vm.mobileOffersDto.banner,
              "custom-class": "bg-warning",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "container-fluid pt-1", attrs: { id: "offer-tiles" } },
        [
          _c(
            "div",
            {
              staticClass:
                "d-flex flex-row justify-content-between align-items-center my-lg-1",
            },
            [
              _c("div", [
                _c("h1", {
                  staticClass: "mb-0 pb-0",
                  domProps: { innerHTML: _vm._s(_vm.mobileOffersDto.title) },
                }),
                _vm._v(" "),
                _vm.mobileOffersDto.subTitle
                  ? _c("div", [
                      _c("p", {
                        staticClass: "h4 mb-0",
                        domProps: {
                          innerHTML: _vm._s(_vm.mobileOffersDto.subTitle),
                        },
                      }),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.mobileOffersDto.digitalCartTooltipDto
                ? _c("div", [
                    _c("div", { staticClass: "row justify-content-end" }, [
                      _c(
                        "div",
                        { staticClass: "col-auto" },
                        [
                          _c("digital-cart-tooltip", {
                            attrs: {
                              title:
                                _vm.mobileOffersDto.digitalCartTooltipDto.title,
                              content:
                                _vm.mobileOffersDto.digitalCartTooltipDto
                                  .content,
                              "cta-label":
                                _vm.mobileOffersDto.digitalCartTooltipDto
                                  .ctaLabel,
                              "cta-url":
                                _vm.mobileOffersDto.digitalCartTooltipDto
                                  .cartPageUrl,
                              "empty-cart":
                                _vm.mobileOffersDto.digitalCartTooltipDto
                                  .emptyCart,
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("ob1-separateur", { staticClass: "my-1" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mb-1 mt-lg-2" },
                  [
                    _vm.mobileOffersDto.openCustomerDto ||
                    _vm.switchOpen ||
                    _vm.mobileOffersDto.discountAdvantagesDto
                      ? _c("switch-live-box-customer", {
                          attrs: {
                            "switch-open": _vm.switchOpen,
                            "open-customer-dto":
                              _vm.mobileOffersDto.openCustomerDto,
                            "discount-advantages-dto":
                              _vm.mobileOffersDto.discountAdvantagesDto,
                          },
                          on: {
                            switch: function ($event) {
                              return _vm.switchLiveBoxCustomerOffers($event)
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm.showRemiseInternetPopin &&
          _vm.mobileOffersDto.remiseInternetPopinComponent
            .remiseInternetPopinComponent
            ? _c("internet-discount-popin-shared", {
                attrs: {
                  id: "remise-offers-open-modal",
                  dto: _vm.mobileOffersDto.remiseInternetPopinComponent
                    .remiseInternetPopinComponent,
                  "offers-list": _vm.getAllOffersFromTabs(),
                  mode: "offers",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showTabs
            ? _c(
                "div",
                { staticClass: "row d-flex justify-content-center mb-2" },
                [
                  _c(
                    "div",
                    { class: _vm.offerTabsClasses },
                    [
                      _vm.mobileOffersDto.tabs &&
                      _vm.mobileOffersDto.tabs.tabsList
                        ? _c("offers-tabs", {
                            attrs: { tabs: _vm.mobileOffersDto.tabs.tabsList },
                            on: { "toggle-tab": _vm.toggleTab },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "row list-unstyled" },
            [
              _c(
                "span",
                {
                  staticClass: "visually-hidden",
                  attrs: { "aria-live": "polite" },
                },
                [_vm._v(_vm._s(_vm.listAccessibilityLabel))]
              ),
              _vm._v(" "),
              _vm._l(_vm.displayedMobileOffersTiles, function (offer, index) {
                return _c(
                  "li",
                  {
                    key: "offer-" + (offer.idSeo || index),
                    staticClass: "col-12 col-md-6 col-lg-4 mb-1 tile-wrapper",
                    attrs: { "data-test-id": "offer-" + index },
                  },
                  [
                    offer.type == "push"
                      ? _c("push-animation-card", { attrs: { offer: offer } })
                      : _c("mobile-offer-card", {
                          attrs: {
                            "data-segment": "segment-data",
                            offer: offer,
                            "section-id": "segment-data",
                            "advantage-offer-mobile-message":
                              _vm.advantageOfferMobileMessage(offer.idSeo),
                            "is-sub": offer.sub,
                            "is-fmr": _vm.switchOpen
                              ? _vm.switchOpen.switchDto.checked
                              : _vm.withOpenPrices,
                            "is-black": offer.promoted,
                            "show-remise-internet-popin":
                              _vm.showRemiseInternetPopin,
                          },
                          on: {
                            "selected-offer-details": _vm.selectedOfferDetails,
                            "add-offer-in-cart": _vm.onAddOfferInCart,
                            "add-offer-in-cart-success":
                              _vm.onAddOfferInCartSuccess,
                            "add-offer-in-cart-error":
                              _vm.onAddOfferInCartError,
                          },
                        }),
                  ],
                  1
                )
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12 text-center mt-1" },
              [
                _vm.showMoreOffersButton
                  ? _c("ob1-boutons", {
                      staticClass: "px-3",
                      attrs: {
                        "is-button": true,
                        "is-secondary": true,
                        "data-test-id": "btn-show-more-offers",
                        label:
                          _vm.moreOffersButton +
                          " (" +
                          _vm.nonPushOffersCount +
                          ")",
                        "data-oevent-category": "liste_forfait",
                        "data-oevent-action": _vm.getLabelToTmsFormat(
                          _vm.moreOffersButton
                        ),
                        "data-oevent-label": "voir_tout",
                      },
                      on: {
                        "ob1-boutons-click": function ($event) {
                          $event.preventDefault()
                          return _vm.sliceMoreOffersSegments(true)
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showLessOffersButton
                  ? _c("ob1-boutons", {
                      staticClass: "px-3",
                      attrs: {
                        "is-button": true,
                        "is-secondary": true,
                        "data-test-id": "btn-show-less-offers",
                        label: _vm.lessOffersButton,
                        "data-oevent-category": "liste_forfait",
                        "data-oevent-action": _vm.getLabelToTmsFormat(
                          _vm.lessOffersButton
                        ),
                        "data-oevent-label": "voir_moins",
                      },
                      on: {
                        "ob1-boutons-click": function ($event) {
                          $event.preventDefault()
                          return _vm.sliceLessOffersSegments(true)
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm.showMobileOffersDetail
            ? _c("offers-detail-popin", {
                ref: "offerDetailsPopin",
                attrs: {
                  id: "offer-details-popin",
                  "new-sub-seo-ids": _vm.mobileOffersDto.newSubSeoIds,
                  "new-sub-message": _vm.mobileOffersDto.newSubMessage,
                  offers: _vm.allSelectedMobileOffersTiles,
                  "logo5g-src": _vm.mobileOffersDto.image5gCds,
                  "logo5g-plus-src": _vm.mobileOffersDto.image5gPlusCds,
                  "show-remise-internet-popin": _vm.showRemiseInternetPopin,
                },
                on: {
                  "change-offer-blocked": _vm.changeOfferBlocked,
                  "add-offer-in-cart": _vm.onAddOfferInCart,
                  "add-offer-in-cart-success": _vm.onAddOfferInCartSuccess,
                  "add-offer-in-cart-error": _vm.onAddOfferInCartError,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.allSelectedMobileOffersTiles, function (offer) {
            return [
              offer.priceDetailsPopin
                ? _c("price-details-popin", {
                    key: "price-details-" + offer.idSeo,
                    attrs: {
                      id: offer.idSeo,
                      "offer-type": offer.offerType || "",
                      "offer-name": offer.secondaryShortLabel,
                      "offer-price": offer.price,
                      "price-details": offer.priceDetailsPopin,
                    },
                  })
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("offers-animation-section", {
        attrs: { "offers-animation": _vm.selectionAnimation },
      }),
      _vm._v(" "),
      _vm.brandAnimation && _vm.brandAnimation.title
        ? _c(
            "section",
            { staticClass: "content-visibility-auto bg-gray2" },
            [
              _c("brand-animation-section", {
                staticClass: "pt-2 container-fluid",
                attrs: { "brand-animation": _vm.brandAnimation },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "container-fluid pt-2 content-visibility-auto" },
        [
          _vm.showInfoAlert5G
            ? _c("info-5g-tile", {
                class: "px-1",
                attrs: {
                  "is-sosh": false,
                  "is-wide": false,
                  title: _vm.mobileOffersDto.infoAlert5G.title,
                  image: _vm.mobileOffersDto.image5gCds,
                  list: _vm.mobileOffersDto.infoAlert5G.list,
                  link: _vm.mobileOffersDto.infoAlert5G.link,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("faq", {
            attrs: {
              title: _vm.mobileOffersDto.faq && _vm.mobileOffersDto.faq.title,
              "question-list":
                _vm.mobileOffersDto.faq && _vm.mobileOffersDto.faq.questionList,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("ob1-snack-bar", {
        ref: "cartPageSnackbar",
        staticClass: "over-page-loading-spinner",
        attrs: {
          id: "cartPageSnackbar",
          icon: _vm.snackbarIcon,
          label: _vm.snackbarMessage,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }